export const FONT_OPTIONS = [
  "Poppins",
  "Roboto",
  "Arial",
  "Helvetica",
  "Georgia",
  "Times New Roman",
  "Verdana",
  "Courier New",
  "Montserrat",
  "Open Sans",
  "Lato",
  "Inter"
];

export const FONT_SIZE_OPTIONS = [
  "10px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "30px",
  "32px",
  "36px",
  "40px",
  "48px"
];

export const FONT_DROPDOWN_STYLE = {
  width: "100%",
  padding: "8px 12px",
  borderRadius: "8px",
  border: "1px solid #D2D6DA",
  fontSize: "14px",
  fontFamily: "inherit",
  backgroundColor: "white",
  cursor: "pointer"
};

export const FONT_SIZE_DROPDOWN_STYLE = {
  width: "100%",
  padding: "8px 8px",
  borderRadius: "8px",
  border: "1px solid #D2D6DA",
  fontSize: "14px",
  fontFamily: "inherit",
  backgroundColor: "white",
  cursor: "pointer"
};
